import React from 'react';
import Helmet from "react-helmet";
import {Card, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import speaker1 from '../../assets/images/contents/speaker1-ProfDrGuanHuaHuang.jpg';

export const ProfessorDrGuanHuaHuang = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">ProfessorDrGuanHuaHuang</li>
      </ol>
    </nav>

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker1} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Professor Dr Guan-Hua Huang</b>
    </p>

    <p style={{textAlign:'center'}}>
      National Yang Ming Chiao Tung University, Taiwan
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Machine Learning Classification of Functional Brain Imaging for 
      Parkinson’s Disease Stage Prediction</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      In this study, we analyze a dataset containing functional brain imaging from 6 normal healthy controls and 196 patients with Parkinson’s 
      disease (PD), which can be divided into 5 stages according to the severity of illness. The goal is to predict patients’ PD illness stages 
      via their functional brain images. Used approaches include multivariate statistical methods, ensemble learning models, and deep convolutional 
      neural network (CNN). For statistical and ensemble models, PCA is performed to extract features, and the best combination of parameters is 
      found by grid search. For CNN modeling, we use the technique of image augmentation to increase data size and adopt transfer learning to 
      incorporate pretrained VGG16 weights and architecture into the model fitting. It is found that the deep CNN model with pretrained VGG16 weights 
      and architecture outperforms other approaches, which can capture significant features from imaging and reach higher classification accuracy.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
      Dr. Huang's research is informed by the fact that in many medical studies, the definitive outcome is inaccessible, and a valid surrogate endpoint is 
      then measured in place of the clinically most meaningful endpoint. Therefore, his primary research interest is in developing latent variable/class 
      models for analyzing this kind of data structure.
    </p>

    <p style={{ textAlign:'justify'}}>
      Dr. Huang is interested in statistical problems in genetics, genomics, and bioinformatics. He is particularly interested in statistical validation of 
      endophenotypes, high-throughput genomic data analysis, gene-gene interaction detection, next-generation sequencing data analysis, and copy number 
      variation identification.
    </p>

    <p style={{ textAlign:'justify'}}>
      Dr. Huang is deeply invested in many scientific areas, including aging, nursing, schizophrenia, diabetes, sensory impairments (hearing, vision, 
      olfaction), and data science.
    </p>


    <p>Click this <a href = "http://ghuang.stat.nctu.edu.tw/" target="_blank" rel="noreferrer">link</a> to see his further detail bio. <br/>
    </p>

  </div>
)